import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { useAppDispatch } from "../../../hooks/hooks";
import useWindowDimensions from "../../../hooks/useWindowsDimensions";
import { forgotPassword, resetPassword } from "../../../redux/auth/actions";
import CustomerAccountSettings from "../../../components/customer/AccountSettings";


interface Steps {
  Email: string;
  NewPassword: string;
  confirmPassword: string;
  otp: string;
}

const CustomerChangePassword: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
  const [stage, setStage] = useState(1);
  const { height, width } = useWindowDimensions();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [steps, setSteps] = useState<Steps>({
    Email: '',
    NewPassword: '',
    confirmPassword: '',
    otp: '',
  });

  const handleSteps = (e: any, key: any) => {
    setSteps({ ...steps, [key]: e.target.value })
  }


  const onFinishStageOne = async () => {
    await setIsLoading(true)
    await dispatch(forgotPassword({
      loginData: {
        "Records": [
          {
            "Email": steps?.Email
          }
        ]
      }
    }))
    await setIsLoading(false)
    setStage(2)
  };

  const onFinishStageTwo = async () => {
    await setIsLoading(true)
    if (steps?.NewPassword === steps?.confirmPassword) {
      await dispatch(resetPassword({
        loginData: {
          "Records": [
            {
              Email: steps?.Email,
              NewPassword: steps?.NewPassword,
              OTP: steps?.otp,
              confirmPassword: steps?.confirmPassword
            }
          ]
        }
      }))
      await setIsLoading(false)
      navigate('/auth/login/customer');
    } else {
      await setIsLoading(false)
      toast.error(
        'NewPassword and Confirm Password must be same',
      );
    }
  };

  const onFinishStageTwoForMobile = async () => {
    await setIsLoading(true)
    if (steps?.NewPassword === steps?.confirmPassword) {
      await dispatch(resetPassword({
        loginData: {
          "Records": [
            {
              Email: steps?.Email,
              NewPassword: steps?.NewPassword,
              OTP: steps?.otp,
              confirmPassword: steps?.confirmPassword
            }
          ]
        }
      }))
      await setIsLoading(false)
      navigate('/auth/login/customer');
    } else {
      await setIsLoading(false)
      toast.error(
        'NewPassword and Confirm Password must be same',
      );
    }
  };

  const onFinishStageTwoForTablet = async () => {
    await setIsLoading(true)
    if (steps?.NewPassword === steps?.confirmPassword) {
      await dispatch(resetPassword({
        loginData: {
          "Records": [
            {
              Email: steps?.Email,
              NewPassword: steps?.NewPassword,
              OTP: steps?.otp,
              confirmPassword: steps?.confirmPassword
            }
          ]
        }
      }))
      await setIsLoading(false)
      navigate('/auth/login/customer');
    } else {
      await setIsLoading(false)
      toast.error(
        'NewPassword and Confirm Password must be same',
      );
    }
  };

  return (
    <>
      {width && width < 720 ? (
        //  Start - Mobile View  
        <div className={`max-h-screen w-screen mt-16 py-5`}>
          {stage === 1 && <form onSubmit={handleSubmit(onFinishStageOne)} >
            <div className="bg-[#F8F8F8]">
              <div className="bg-white flex flex-col justify-around w-full h-full p-10 pt-4">
                <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                  Change Password
                  <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                </div>
                <div className="w-full my-5">
                  <label
                    className="block text-sm font-normal mb-2" >
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    {...register('Email', {
                      required: true,
                      pattern:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                    className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Enter your Email"
                    onChange={(e) => handleSteps(e, 'Email')}
                  />
                  {errors.Email && errors.Email.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                  )}
                  {errors.Email && errors.Email.type === "pattern" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
                  )}
                </div>
                <div className="text-center my-4">
                  <button type="submit"
                    disabled={isLoading}
                    className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                      } flex-row flex items-center justify-center text-light rounded font-semibold p-4 w-full h-12`}
                  >
                    Request OTP
                    <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                      <RotatingLines
                        visible={true}
                        width={'20'}
                        strokeColor="#fff"
                        strokeWidth="6"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div >
          </form >
          }
          {stage === 2 && <form onSubmit={handleSubmit(onFinishStageTwoForMobile)} >
            <div className="bg-[#F8F8F8]">
              <div className="bg-white flex flex-col justify-around w-full h-full p-10 pt-4">
                <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                  Change Password
                  <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                </div>
                <div className="w-full my-3">
                  <label
                    className="block text-sm font-normal mb-2" >
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    {...register('Email', {
                      required: true,
                      pattern:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                    className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Email"
                    onChange={(e) => handleSteps(e, 'Email')}
                  />
                  {errors.Email && errors.Email.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                  )}
                  {errors.Email && errors.Email.type === "pattern" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
                  )}
                </div>
                <div className="w-full my-3">
                  <label
                    className="block  text-black text-sm font-normal mb-2"
                  >
                    New Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    {...register('NewPassword', { required: true, maxLength: 15 })}
                    className="border-0 px-3 py-3 text-indigo-600 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="New Password"
                    onChange={(e) => handleSteps(e, 'NewPassword')}
                  />
                  {errors.NewPassword && errors.NewPassword.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                  )}
                  {errors.NewPassword && errors.NewPassword.type === "maxLength" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
                  )}
                </div>
                <div className="w-full my-3">
                  <label
                    className="block text-black text-sm font-normal mb-2"
                  >
                    Confirm Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    {...register('confirmPassword', { required: true, maxLength: 15 })}
                    className="border-0 px-3 py-3  text-indigo-600 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="confirm Password"
                    onChange={(e) => handleSteps(e, 'confirmPassword')}
                  />
                  {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                  )}
                  {errors.confirmPassword && errors.confirmPassword.type === "maxLength" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
                  )}
                </div>
                <div className="w-full my-3">
                  <label
                    className="block text-black text-sm font-normal mb-2"
                  >
                    OTP <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
                    type="number"
                    placeholder="OTP"
                    {...register('otp', {
                      required: `OTP is required`,
                    })}
                    onChange={(e) => {
                      handleSteps(e, 'otp');
                    }}
                  />
                </div>
                <div className="text-center my-4">
                  <button type="submit"
                    disabled={isLoading}
                    className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                      } flex-row flex items-center justify-center text-light rounded font-semibold p-4 w-full h-12`}
                  >
                    Reset Password
                    <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                      <RotatingLines
                        visible={true}
                        width={'20'}
                        strokeColor="#fff"
                        strokeWidth="6"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form >}
        </div>
        //  End - Mobile View   
      ) : width && width >= 720 && width < 1024 ? (
        //  Start - Tablet View
        <div className={`max-h-screen w-screen mt-20 py-5`}>
          {stage === 1 && <form onSubmit={handleSubmit(onFinishStageOne)} >
            <div className="bg-[#F8F8F8] p-10">
              <div className="bg-white flex flex-col justify-around w-full h-full p-10 pt-4">
                <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                  Change Password
                  <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                </div>
                <div className="w-full my-5">
                  <label
                    className="block text-lg font-medium mb-2" >
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    {...register('Email', {
                      required: true,
                      pattern:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                    className="border-0 px-4 py-4 text-black rounded text-lg shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Enter your Email"
                    onChange={(e) => handleSteps(e, 'Email')}
                  />
                  {errors.Email && errors.Email.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm my-1">This is required</span>
                  )}
                  {errors.Email && errors.Email.type === "pattern" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm px-3">Please enter valid email id</span>
                  )}
                </div>
                <div className="text-center my-4">
                  <button type="submit"
                    disabled={isLoading}
                    className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                      } flex-row flex items-center justify-center text-light text-lg rounded font-semibold p-4 w-full h-12`}
                  >
                    Request OTP
                    <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                      <RotatingLines
                        visible={true}
                        width={'20'}
                        strokeColor="#fff"
                        strokeWidth="6"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div >
          </form >
          }
          {stage === 2 && <form onSubmit={handleSubmit(onFinishStageTwoForTablet)} >
            <div className="bg-[#F8F8F8] p-10">
              <div className="bg-white flex flex-col justify-around w-full h-full p-10 pt-4">
                <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                  Change Password
                  <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                </div>
                <div className="w-full my-3">
                  <label
                    className="block text-black text-lg font-medium mb-2" >
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    {...register('Email', {
                      required: true,
                      pattern:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                    className="border-0 px-4 py-4 text-black rounded text-lg shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Email"
                    onChange={(e) => handleSteps(e, 'Email')}
                  />
                  {errors.Email && errors.Email.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm my-1">This is required</span>
                  )}
                  {errors.Email && errors.Email.type === "pattern" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm px-3">Please enter valid email id</span>
                  )}
                </div>
                <div className="w-full my-3">
                  <label
                    className="block  text-black text-lg font-medium mb-2"
                  >
                    New Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    {...register('NewPassword', { required: true, maxLength: 15 })}
                    className="border-0 px-4 py-4 text-indigo-600 rounded text-lg shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="New Password"
                    onChange={(e) => handleSteps(e, 'NewPassword')}
                  />
                  {errors.NewPassword && errors.NewPassword.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm my-1">This is required</span>
                  )}
                  {errors.NewPassword && errors.NewPassword.type === "maxLength" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm my-1">Max length exceeded</span>
                  )}
                </div>
                <div className="w-full my-3">
                  <label
                    className="block text-black text-lg font-medium mb-2"
                  >
                    Confirm Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    {...register('confirmPassword', { required: true, maxLength: 15 })}
                    className="border-0 px-4 py-4  text-indigo-600 rounded text-lg shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="confirm Password"
                    onChange={(e) => handleSteps(e, 'confirmPassword')}
                  />
                  {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm my-1">This is required</span>
                  )}
                  {errors.confirmPassword && errors.confirmPassword.type === "maxLength" && (
                    <span role="alert" className="w-full text-red-500 bg-white text-sm my-1">Max length exceeded</span>
                  )}
                </div>
                <div className="w-full my-3">
                  <label
                    className="block text-black text-lg font-medium mb-2"
                  >
                    OTP <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="text-gray-900 text-lg rounded-lg shadow border-0 focus:ring-primary-600 focus:border-primary-600 block w-full p-4"
                    type="number"
                    placeholder="OTP"
                    {...register('otp', {
                      required: `OTP is required`,
                    })}
                    onChange={(e) => {
                      handleSteps(e, 'otp');
                    }}
                  />
                </div>
                <div className="text-center my-4">
                  <button type="submit"
                    disabled={isLoading}
                    className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                      } flex-row flex items-center justify-center text-light text-lg rounded font-semibold p-4 w-full h-12`}
                  >
                    Reset Password
                    <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                      <RotatingLines
                        visible={true}
                        width={'20'}
                        strokeColor="#fff"
                        strokeWidth="6"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form >}
        </div>
        //  End - Tablet View
      ) : (
        //  Start - Web View 
        <div className="h-screen flex flex-col justify-between items-stretch bg-white">
          <div className="flex flex-row">
            <CustomerAccountSettings />
            <div className="w-3/4  justity-center items-center">
              <div className="contact-wrapper w-full ">
                {stage === 1 && <form onSubmit={handleSubmit(onFinishStageOne)} >
                  <div className="flex bg-[#F8F8F8] h-full">
                    <div className="container mx-auto ">
                      <div className="flex content-center items-center justify-center h-full">

                        <div className="bg-white flex flex-col items-end justify-around w-full h-full">
                          <div className="flex flex-col justify-center w-full px-20 pt-20 ">
                            <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                              Change Password
                              <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                            </div>
                            <div className="w-full my-5">
                              <label
                                className="block text-sm font-light mb-2" >
                                Email Address <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                {...register('Email', {
                                  required: true,
                                  pattern:
                                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                })}
                                className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                placeholder="Email"
                                onChange={(e) => handleSteps(e, 'Email')}
                              />
                              {errors.Email && errors.Email.type === "required" && (
                                <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                              )}
                              {errors.Email && errors.Email.type === "pattern" && (
                                <span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
                              )}
                            </div>
                            <div className="text-center mt-6">
                              <button type="submit"
                                disabled={isLoading}
                                className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                  } flex-row flex items-center justify-center text-light rounded font-semibold p-4 w-full h-12`}
                              >
                                Request OTP
                                <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                  <RotatingLines
                                    visible={true}
                                    width={'20'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                  />
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div >
                </form >
                }
                {stage === 2 && <form onSubmit={handleSubmit(onFinishStageTwo)} >
                  <div className="flex h-screen bg-[#F8F8F8]">
                    <div className="container mx-auto  ">
                      <div className="flex content-center items-center justify-center h-full">
                        <div className="w-full h-max ">
                          <div className="bg-white flex flex-col items-end justify-around h-full">
                            <div className="flex flex-col justify-center w-full h-screen px-20 pb-16">
                              <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                                Change Password
                                <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                              </div>
                              <div className="w-full my-2">
                                <label
                                  className="block text-sm font-light mb-2" >
                                  Email Address <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  {...register('Email', {
                                    required: true,
                                    pattern:
                                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                  })}
                                  className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder="Email"
                                  onChange={(e) => handleSteps(e, 'Email')}
                                />
                                {errors.Email && errors.Email.type === "required" && (
                                  <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                                )}
                                {errors.Email && errors.Email.type === "pattern" && (
                                  <span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
                                )}
                              </div>
                              <div className="w-full my-2">
                                <label
                                  className="block text-black text-sm font-light mb-2"
                                >
                                  New Password <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="password"
                                  {...register('NewPassword', { required: true, maxLength: 15 })}
                                  className="border-0 px-3 py-3  text-indigo-600 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder="New Password"
                                  onChange={(e) => handleSteps(e, 'NewPassword')}
                                />
                                {errors.NewPassword && errors.NewPassword.type === "required" && (
                                  <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                                )}
                                {errors.NewPassword && errors.NewPassword.type === "maxLength" && (
                                  <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
                                )}
                              </div>
                              <div className="w-full my-2">
                                <label
                                  className="block text-black text-sm font-light mb-2"
                                >
                                  Confirm Password <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="password"
                                  {...register('confirmPassword', { required: true, maxLength: 15 })}
                                  className="border-0 px-3 py-3  text-indigo-600 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                  placeholder="confirm Password"
                                  onChange={(e) => handleSteps(e, 'confirmPassword')}
                                />
                                {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                                  <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
                                )}
                                {errors.confirmPassword && errors.confirmPassword.type === "maxLength" && (
                                  <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
                                )}
                              </div>
                              <div className="w-full my-2">
                                <label
                                  className="block text-black text-sm font-light mb-2"
                                >
                                  OTP <span className="text-red-500">*</span>
                                </label>
                                <input
                                  className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
                                  type="number"
                                  placeholder="OTP"
                                  {...register('otp', {
                                    required: `OTP is required`,
                                  })}
                                  onChange={(e) => {
                                    handleSteps(e, 'otp');
                                  }}
                                />
                              </div>
                              <div className="text-center mt-6">
                                <button type="submit"
                                  disabled={isLoading}
                                  className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                    } flex-row flex items-center justify-center text-light rounded font-semibold p-4 w-full h-12`}
                                >
                                  Reset Password
                                  <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                    <RotatingLines
                                      visible={true}
                                      width={'20'}
                                      strokeColor="#fff"
                                      strokeWidth="6"
                                      animationDuration="0.75"
                                      ariaLabel="rotating-lines-loading"
                                    />
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div >
                </form >
                }
              </div>
            </div>
          </div>
        </div>
        //  End - Web View  
      )}
    </>
  )
};

export default CustomerChangePassword;
